import React from 'react'
import Bredcrumb from '../Common/Bredcrumb'
import { Link } from 'react-router-dom'

const AntiRaggingCommittee = () => {
  return (
    <>
      <Bredcrumb title="Anti Ragging Committee" />
      <section className='mt-4'>
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="common-section-item">                              
                              <div class="card">
                                <div class="card-body card-body-item">
                                  <div class="common-section-item">
                                   <p class="mb-3">This is to inform to all the concerns that the following persons are nominated as members of Anti Ragging Committee for session 2025-26.</p>
                                    <table class="table table-striped">
                                    <thead>
                                      <tr>
                                          <th>S.N.</th>
                                          <th>Designation</th>
                                          <th>Name</th>
                                          <th>Contact No.</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td>Directed by</td>
                                        <td>Dr. Zeashan Hussaian </td>
                                        <td>9935844704</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td>Headed by</td>
                                        <td>Dr. Meena Yadav</td>
                                        <td>9919991177</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td>Coordinator</td>
                                        <td>Mr. Rishabh Maurya</td>
                                        <td>9889919844</td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td>Internal Committee</td>
                                        <td>Dr. Raziuddin Khan</td>
                                        <td>8090183694</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td>Internal Committee </td>
                                        <td>Mr. Anand Km Srivastava</td>
                                        <td>9369229157</td>
                                    </tr>
                                    
                                    <tr>
                                        <td>6.</td>
                                        <td>External Committee</td>
                                        <td>Mr. Jitendra Pratap SIngh</td>
                                        <td>8707380537</td>
                                    </tr>
                                    <tr>
                                        <td>7.</td>
                                        <td>External Committe</td>
                                        <td>Mr. Mohd Yusuf</td>
                                        <td>8543052518</td>
                                    </tr>
                                    <tr>
                                        <td>8.</td>
                                        <td>4th  Year Student Representative B.Pharm</td>
                                        <td>Mr. Shiva Yadav </td>
                                        <td>8112525037</td>
                                    </tr>
                                    <tr>
                                        <td>9.</td>
                                        <td>4th  Year Student Representative B.Pharm</td>
                                        <td>Mr. Sabir Zafar </td>
                                        <td>7779960799</td>
                                    </tr>
                                    <tr>
                                        <td>10.</td>
                                        <td>3rd Year Student Representative B.Pharm</td>
                                        <td>Mr. Adarsh Mishra</td>
                                        <td>6393324940</td>
                                    </tr>
                                    <tr>
                                        <td>11.</td>
                                        <td>3rd Year Student Representative B.Pharm</td>
                                        <td>Ms. Riya Singh </td>
                                        <td>9546059062</td>
                                    </tr>
                                    <tr>
                                        <td>12.</td>
                                        <td>2nd Year Student Representative B.Pharm</td>
                                        <td>Mr. Sonu Singh</td>
                                        <td>7355205999</td>
                                    </tr>
                                    <tr>
                                        <td>13.</td>
                                        <td>2nd Year Student Representative B.Pharm</td>
                                        <td>Mr. Ayushman Dubey</td>
                                        <td>8887570178</td>
                                    </tr> 
                                    <tr>
                                        <td>14.</td>
                                        <td>1st Year Student Representative B.Pharm</td>
                                        <td>Mr. Aditya Singh</td>
                                        <td>7393861057</td>
                                    </tr> 
                                    <tr>
                                        <td>15.</td>
                                        <td>1st Year Student Representative B.Pharm</td>
                                        <td>Mr. Adarsh Srivastava</td>
                                        <td>7307439330</td>
                                    </tr> 
                                    <tr>
                                        <td>16.</td>
                                        <td>1st Year Student Representative D.Pharm</td>
                                        <td>Ms. Chandra Rajbhar </td>
                                        <td>7007589009</td>
                                    </tr> 
                                    <tr>
                                        <td>17.</td>
                                        <td>1st Year Student Representative D.Pharm</td>
                                        <td>Mr. Aman Gupta</td>
                                        <td>8574667772</td>
                                    </tr> 
                                    <tr>
                                        <td>18.</td>
                                        <td>2nd Year Student Representative D.Pharm</td>
                                        <td>Mr. Anupam Maurya </td>
                                        <td>7268808639</td>
                                    </tr> 
                                    <tr>
                                        <td>19.</td>
                                        <td>2nd Year Student Representative D.Pharm</td>
                                        <td>Mr. Sachin Pal</td>
                                        <td>9984454871</td>
                                    </tr> 
                                    </tbody>
                                    </table>
                                    {/* <p className='mb-2 text-right'><h5>Dr. Zeashan Hussain</h5></p>
                                      <p className='mb-0 text-right'>Director</p> */}
                                  </div>                                 
                                </div>
                              </div>
                              {/* <div class="common-section-img">
                                  <img src="img/content/640x360.png" alt="" class="border-radius-6" />
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="sidebar">                          
                          <div class="common-section-item">
                            <div class="card">
                              <div class="card-body">
                                <h4 class="title-bg title-bg-default">Committees</h4>
                                <ul class="sidebar-links">
                                  <li><Link to={'/AntiDiscriminationCommittee'}>Anti Discrimination Committee</Link></li>
                                  <li><Link to={'/AntiRaggingCommittee'}>Anti Ragging Committee</Link></li>
                                  <li><Link to={'/SCSTCommittee'}>SC/ST Standing Committee</Link></li>
                                  <li><Link to={'/GenderSensitizationCommittee'}>Gender Sensitization Committee</Link></li>
                                  <li><Link to={'/StudentGrievanceRedressalCommittee'}>Student Grievance Redressal Committee</Link></li>
                                </ul>
                              </div>
                            </div>
                          </div>                        
                        </div>
                      </div>
                    </div>
            </div>
        </section>
    </>
  )
}

export default AntiRaggingCommittee
